import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getLegPointsSelector } from '../../../selectors/sended-data';
import { findNearestPointByTime } from '../../../service/alert/findNearestPointByTime';
import { deepArrayCompare } from '../../../service/utils';

const DEFAULT_TIME_FOR_CHECK = 'eto_default';

export const usePoints = (legId) => {
    const legPointsSelector = getLegPointsSelector(legId);
    const points = useSelector((state) => legPointsSelector(state), deepArrayCompare);
    const timeForCheck = useSelector((state) => {
        const columnsDeclaration = state.routesDeclaration.columnsDeclaration || [];
        for (const column of columnsDeclaration) {
            if (!column) {
                continue;
            }

            if (column?.items) {
                for (const item of column.items) {
                    if (item?.alert) {
                        return item.alert;
                    }
                }
            }
        }

        return DEFAULT_TIME_FOR_CHECK;
    });

    return useCallback((nowUtc) => findNearestPointByTime(points, timeForCheck, nowUtc), [points, timeForCheck]);
};
